import React from 'react';
import gbPng from './flags/gb.png';
import germanyPng from './flags/germany.png';
import greecePng from './flags/greece.png';
import japanPng from './flags/japan.png';
import russiaPng from './flags/russia.png';
import canadaPng from './flags/canada.png';
import irelandPng from './flags/ireland.png';
import polandPng from './flags/poland.png';
import chinaPng from './flags/china.png';
import spainPng from './flags/spain.png';

const FLAGS_MAP = {
  'en-gb': { src: gbPng, alt: 'Flag of GB' },
  'de-de': { src: germanyPng, alt: 'Flag of Germany' },
  'ja-jp': { src: japanPng, alt: 'Flag of Japan' },
  'el-gr': { src: greecePng, alt: 'Flag of Greece' },
  'ru-ru': { src: russiaPng, alt: 'Flag of Russia' },
  'en-ca': { src: canadaPng, alt: 'Flag of Canada' },
  'en-ie': { src: irelandPng, alt: 'Flag of Ireland' },
  pl: { src: polandPng, alt: 'Flag of Poland' },
  'zh-cn': { src: chinaPng, alt: 'Flag of China' },
  'zh-hk': { src: chinaPng, alt: 'Flag of China' },
  'es-es': { src: spainPng, alt: 'Flag of Spain' },
};

export const renderFlag = (locale) => {
  const flagProps = FLAGS_MAP[locale];
  if (!flagProps) return null;

  return <img style={{ height: '100%' }} {...flagProps} />;
};
